const MontaniaIcon = ({
    size,
    width = 36,
    height = 36,
    color = "#0468fb",
    ...rest
  }) => {

    const w = width  ?? size;
    const h = height ?? size;

    return (
       <svg viewBox="0 0 1080 1080" width={w} height={h} version="1.1" xmlns="http://www.w3.org/2000/svg" >
       
       <g transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
       fill={color} stroke="none">
       <path d="M5180 9390 c0 -6 -48 -10 -125 -10 -77 0 -125 -4 -125 -10 0 -5 -24
       -10 -54 -10 -30 0 -58 -4 -61 -10 -3 -5 -17 -10 -31 -10 -13 0 -24 -4 -24 -10
       0 -5 -18 -10 -40 -10 -22 0 -40 -4 -40 -10 0 -5 -25 -10 -55 -10 -30 0 -55 5
       -55 10 0 6 -27 10 -60 10 -33 0 -60 -4 -60 -10 0 -5 -19 -10 -43 -10 -31 0
       -46 -5 -57 -20 -8 -11 -20 -20 -27 -20 -7 0 -13 -6 -13 -13 0 -9 -12 -11 -39
       -9 -21 2 -42 -1 -45 -7 -4 -6 -21 -11 -37 -11 -17 0 -32 -6 -35 -14 -3 -8 -12
       -12 -20 -9 -26 10 -64 -6 -64 -27 0 -11 -5 -20 -11 -20 -5 0 -7 -4 -4 -10 4
       -6 -5 -10 -19 -10 -14 0 -26 -4 -26 -10 0 -5 -20 -10 -45 -10 -25 0 -45 -3
       -45 -7 0 -9 -49 -33 -67 -33 -7 0 -13 -6 -13 -14 0 -9 -7 -12 -20 -9 -15 4
       -20 0 -20 -16 0 -18 -6 -21 -38 -21 -28 0 -42 -6 -56 -25 -13 -18 -32 -26 -67
       -31 -40 -5 -49 -10 -49 -26 0 -23 -23 -48 -44 -48 -9 0 -16 -5 -16 -11 0 -6
       -7 -9 -15 -5 -8 3 -21 -1 -29 -9 -8 -8 -22 -15 -30 -15 -9 0 -16 -8 -16 -18 0
       -26 -20 -42 -51 -42 -18 0 -28 -6 -32 -20 -3 -11 -12 -20 -21 -20 -9 0 -16 -6
       -16 -13 0 -7 -11 -13 -27 -12 -19 0 -29 -6 -31 -19 -6 -27 -72 -85 -97 -86
       -29 -1 -55 -24 -55 -49 0 -12 -4 -19 -10 -16 -5 3 -10 3 -10 -2 0 -7 -28 -22
       -72 -37 -10 -3 -18 -14 -18 -25 0 -11 -5 -23 -10 -26 -6 -4 -8 -10 -5 -14 2
       -5 -7 -6 -20 -3 -20 3 -25 0 -25 -15 0 -24 -19 -43 -42 -43 -10 0 -18 -7 -18
       -16 0 -8 -4 -12 -10 -9 -5 3 -10 1 -10 -4 0 -6 -9 -11 -20 -11 -13 0 -20 -7
       -20 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -9 -10 -20 0 -12 -13 -25 -35 -36 -20
       -9 -35 -24 -35 -33 0 -20 -40 -61 -59 -61 -17 0 -61 -46 -61 -65 0 -8 -4 -15
       -10 -15 -5 0 -10 -9 -10 -21 0 -26 -23 -49 -49 -49 -17 0 -21 -6 -21 -29 0
       -21 -10 -39 -32 -60 -18 -17 -36 -31 -40 -31 -5 0 -8 -13 -8 -30 0 -16 -4 -30
       -9 -30 -18 0 -71 -59 -71 -79 0 -23 -41 -71 -60 -71 -20 0 -50 -41 -50 -68 0
       -16 -9 -37 -20 -47 -11 -10 -20 -24 -20 -30 0 -7 -8 -15 -18 -18 -11 -2 -22
       -17 -25 -36 -4 -18 -13 -31 -22 -31 -11 0 -15 -10 -15 -35 0 -19 -4 -35 -10
       -35 -5 0 -10 -12 -10 -26 0 -31 -21 -54 -49 -54 -17 0 -21 -6 -21 -29 0 -17
       -4 -33 -10 -36 -5 -3 -10 -18 -10 -33 0 -16 -8 -32 -19 -39 -11 -7 -21 -26
       -23 -45 -2 -25 -9 -34 -28 -38 -23 -5 -25 -11 -28 -68 -2 -38 -8 -65 -15 -68
       -8 -3 -12 -20 -10 -44 1 -22 -2 -40 -8 -40 -5 0 -9 -9 -9 -20 0 -11 -7 -20
       -16 -20 -11 0 -14 -6 -9 -20 5 -15 2 -20 -10 -20 -14 0 -16 -9 -13 -50 3 -43
       0 -50 -17 -52 -16 -2 -21 -12 -23 -43 -2 -22 -10 -43 -17 -48 -8 -4 -12 -14
       -9 -22 4 -8 1 -15 -5 -15 -6 0 -11 -17 -11 -39 0 -22 -4 -43 -10 -46 -5 -3
       -10 -39 -10 -80 0 -82 -6 -105 -26 -105 -11 0 -14 -18 -14 -75 0 -43 -4 -75
       -10 -75 -5 0 -10 -12 -10 -26 0 -14 -6 -32 -14 -39 -11 -11 -14 -41 -13 -120
       1 -58 -1 -105 -5 -105 -5 0 -8 -175 -8 -390 0 -214 3 -390 8 -390 4 0 6 -37 4
       -82 -4 -94 5 -171 19 -163 5 4 9 -14 9 -39 0 -25 5 -46 10 -46 6 0 10 -35 10
       -86 0 -81 1 -86 20 -81 19 5 20 0 20 -88 0 -52 4 -97 10 -100 5 -3 10 -17 10
       -31 0 -13 5 -24 10 -24 6 0 8 -10 4 -24 -3 -14 0 -29 10 -39 9 -8 16 -25 16
       -37 0 -22 21 -50 38 -50 4 0 7 -13 4 -29 -2 -16 1 -32 7 -35 6 -4 11 -25 11
       -47 0 -28 4 -39 15 -39 8 0 15 -9 15 -20 0 -11 4 -20 9 -20 5 0 8 -19 8 -42 0
       -27 4 -42 12 -41 6 2 11 -11 11 -31 0 -26 5 -36 20 -41 15 -5 20 -15 20 -41 0
       -19 3 -34 8 -34 8 0 32 -49 32 -67 0 -15 31 -33 59 -33 17 0 52 15 101 42 8 4
       26 13 40 19 14 6 33 15 42 20 10 5 30 9 46 9 19 0 39 11 60 32 17 18 48 42 69
       53 21 10 57 36 80 57 24 21 51 38 62 38 10 0 24 7 32 16 7 8 38 32 68 51 31
       20 79 56 106 80 28 24 78 68 112 98 35 30 72 55 82 55 11 0 28 12 38 27 23 33
       65 74 143 138 61 50 83 71 143 135 18 19 46 47 62 61 17 15 73 73 125 129 52
       57 111 113 131 126 20 12 45 40 56 61 11 21 62 82 113 136 51 53 101 114 112
       135 11 20 40 60 65 87 24 28 71 80 103 117 33 37 60 72 60 78 0 6 14 23 30 37
       17 13 30 33 30 44 0 11 17 38 38 62 20 23 42 49 47 58 6 10 25 38 43 63 17 26
       32 53 32 61 0 7 15 31 33 54 17 22 46 59 62 82 17 22 47 60 68 83 21 25 37 54
       37 68 0 14 8 36 18 49 27 37 42 67 42 84 0 8 13 29 28 47 31 37 58 76 85 128
       11 19 30 46 43 61 13 14 24 36 24 50 0 13 18 50 40 82 22 31 40 66 40 77 0 10
       5 22 10 25 6 3 10 15 10 25 0 11 12 34 28 52 54 65 72 98 72 130 0 19 8 45 17
       58 31 44 63 113 63 136 0 13 12 38 28 56 33 40 52 73 52 92 0 7 9 25 20 39 11
       14 20 39 20 55 0 17 5 34 10 37 6 3 10 15 10 25 0 11 11 35 24 55 14 20 26 40
       28 45 8 23 61 -7 112 -64 31 -33 66 -71 78 -83 13 -12 118 -115 234 -229 115
       -113 218 -210 227 -216 10 -5 54 -45 100 -89 45 -44 94 -87 109 -95 37 -19 50
       -48 50 -105 0 -58 -19 -103 -62 -144 -29 -28 -37 -40 -77 -117 -9 -18 -28 -47
       -42 -65 -14 -18 -39 -51 -56 -73 -16 -23 -46 -60 -65 -83 -19 -23 -44 -58 -54
       -77 -11 -19 -33 -51 -50 -71 -17 -20 -47 -57 -66 -83 -19 -26 -47 -62 -62 -81
       -16 -18 -28 -37 -28 -42 0 -5 -13 -22 -30 -38 -16 -16 -30 -37 -30 -48 0 -11
       -35 -56 -78 -101 -43 -44 -91 -101 -107 -126 -17 -25 -34 -47 -40 -49 -18 -7
       -175 -164 -175 -175 0 -6 -45 -56 -100 -111 -55 -55 -100 -104 -100 -109 0
       -28 -286 -323 -325 -336 -39 -13 -90 -66 -99 -102 -4 -18 -15 -30 -30 -34 -13
       -3 -36 -19 -50 -35 -14 -16 -32 -29 -38 -29 -7 0 -24 -11 -38 -24 -14 -14 -46
       -43 -72 -66 -26 -23 -50 -50 -53 -61 -4 -10 -18 -22 -33 -25 -15 -4 -55 -32
       -89 -63 -108 -98 -163 -141 -181 -141 -10 0 -38 -21 -62 -46 -25 -25 -61 -52
       -80 -61 -19 -9 -58 -37 -87 -62 -133 -117 -181 -151 -210 -151 -9 0 -35 -18
       -59 -40 -26 -24 -53 -40 -68 -40 -15 0 -44 -17 -71 -40 -25 -22 -53 -40 -61
       -40 -16 0 -58 -27 -112 -72 -18 -16 -44 -28 -58 -28 -14 0 -37 -9 -51 -20 -14
       -11 -32 -20 -41 -20 -8 0 -30 -13 -49 -30 -25 -22 -44 -30 -72 -30 -40 0 -105
       -22 -116 -39 -9 -15 -66 -41 -89 -41 -12 0 -34 -9 -51 -20 -16 -11 -35 -20
       -42 -20 -6 0 -43 -18 -82 -40 -45 -25 -83 -40 -105 -40 -19 0 -38 -4 -41 -10
       -3 -5 -16 -10 -27 -10 -12 0 -32 -10 -45 -22 -19 -18 -27 -20 -42 -11 -15 10
       -20 8 -29 -12 -10 -22 -17 -24 -67 -23 -34 1 -60 -3 -64 -10 -5 -8 -25 -10
       -56 -7 -32 2 -52 0 -57 -8 -8 -13 -138 -17 -138 -4 0 4 -7 7 -15 7 -8 0 -15
       -4 -15 -10 0 -5 -11 -10 -24 -10 -15 0 -26 -7 -29 -20 -3 -14 -14 -20 -31 -20
       -16 0 -26 -6 -26 -15 0 -8 5 -15 10 -15 6 0 10 -4 10 -10 0 -6 -26 -10 -59
       -10 -33 0 -63 -4 -66 -10 -3 -5 -17 -10 -30 -10 -13 0 -27 -4 -30 -10 -3 -5
       -21 -10 -40 -10 -19 0 -37 -4 -40 -10 -3 -5 -44 -10 -91 -10 -77 0 -84 -2 -84
       -20 0 -16 -7 -20 -35 -20 -19 0 -35 -4 -35 -10 0 -5 -13 -10 -29 -10 -17 0
       -33 -4 -36 -10 -3 -5 -17 -10 -30 -10 -13 0 -27 -4 -30 -10 -3 -6 -50 -10
       -105 -10 -55 0 -102 -4 -105 -10 -4 -6 -70 -10 -165 -10 -95 0 -161 -4 -165
       -10 -3 -5 -37 -10 -76 -10 -39 0 -69 -4 -69 -10 0 -6 -52 -10 -135 -10 -83 0
       -135 -4 -135 -10 0 -5 -18 -10 -40 -10 -32 0 -40 -4 -40 -18 0 -38 19 -42 181
       -42 95 0 160 -4 164 -10 4 -6 152 -10 410 -10 258 0 406 -4 410 -10 9 -15 25
       -12 25 5 0 13 26 15 173 15 110 0 177 4 184 11 7 7 66 9 172 7 105 -2 161 1
       161 7 0 7 28 9 73 7 58 -3 77 -1 90 12 11 11 34 16 77 16 57 0 62 2 57 20 -5
       19 0 20 79 20 49 0 84 4 84 10 0 6 20 10 44 10 24 0 46 5 48 11 3 9 9 9 25 0
       31 -16 60 -14 68 7 6 16 7 16 19 0 17 -23 34 -23 38 -1 2 14 12 17 48 15 36
       -3 50 1 64 17 11 12 27 21 38 21 10 0 18 3 18 8 0 12 54 34 58 22 2 -5 30 -10
       62 -10 49 0 67 5 105 31 25 17 50 40 57 52 17 33 27 37 96 37 34 0 62 4 62 10
       0 6 12 10 28 10 31 0 46 9 54 31 6 16 56 29 115 29 17 0 35 5 38 10 3 6 17 10
       30 10 13 0 26 4 30 9 3 5 19 12 36 16 17 4 33 13 36 22 3 8 11 12 18 9 8 -3
       23 4 35 14 12 10 36 22 53 25 18 4 39 13 47 20 34 28 113 65 140 65 16 0 32 5
       35 10 3 6 17 10 30 10 13 0 27 5 30 10 3 5 17 10 31 10 13 0 24 4 24 8 0 5 22
       18 49 30 27 12 52 26 56 32 3 5 21 10 39 10 22 0 40 8 56 25 26 27 74 55 97
       55 18 0 51 19 91 53 18 15 43 27 56 27 30 0 77 24 102 51 26 29 118 89 136 89
       9 0 22 7 29 16 20 24 86 64 105 64 9 0 36 18 60 40 24 22 51 40 60 40 9 0 36
       18 60 40 24 22 50 40 57 40 26 0 72 29 117 75 28 28 53 45 68 45 15 0 45 19
       79 50 30 28 61 50 68 50 14 0 75 65 75 80 0 5 12 13 28 16 15 4 59 38 98 75
       40 38 78 69 85 69 7 0 25 11 39 25 32 32 132 117 206 175 47 36 229 211 616
       588 55 54 156 172 172 202 24 45 89 114 143 151 23 16 45 39 49 52 3 12 13 29
       20 37 38 42 75 77 103 99 17 13 31 31 31 41 0 10 6 20 13 23 10 4 10 7 0 18
       -7 7 -13 26 -13 41 0 25 -3 28 -34 28 -32 0 -42 6 -136 82 -8 7 -119 114 -246
       238 -127 124 -237 230 -245 237 -8 7 -27 30 -44 53 -16 22 -45 59 -62 81 -42
       52 -41 77 1 120 19 19 48 61 65 93 17 32 41 70 54 85 12 15 31 44 42 64 32 61
       93 59 119 -3 6 -16 33 -47 59 -70 26 -23 47 -48 47 -55 0 -12 147 -167 397
       -417 29 -29 90 -92 136 -140 108 -115 123 -116 211 -24 79 83 116 130 116 149
       0 8 9 26 20 40 11 14 20 28 20 32 0 4 14 27 30 52 17 24 30 51 30 59 0 8 18
       34 40 58 22 24 40 51 40 60 0 19 24 60 56 96 12 14 24 39 26 55 2 23 9 31 26
       33 19 3 40 -13 97 -73 40 -43 93 -98 119 -124 120 -120 175 -175 219 -218 288
       -284 349 -342 369 -345 25 -3 37 -43 19 -61 -6 -6 -11 -18 -11 -28 0 -9 -13
       -33 -30 -54 -16 -21 -30 -44 -30 -52 0 -21 -21 -53 -75 -115 -102 -117 -125
       -145 -125 -154 0 -6 -22 -32 -50 -59 -27 -27 -50 -54 -50 -60 0 -6 -22 -33
       -50 -60 -27 -27 -50 -58 -50 -68 0 -11 -36 -55 -80 -98 -44 -44 -80 -84 -80
       -90 0 -8 -103 -126 -158 -181 -4 -3 -19 -19 -34 -35 -79 -83 -254 -253 -375
       -366 -76 -70 -169 -157 -207 -192 -38 -36 -74 -65 -79 -65 -6 0 -32 -19 -58
       -42 -27 -24 -73 -63 -104 -88 -31 -25 -79 -65 -108 -91 -61 -53 -101 -79 -121
       -79 -8 0 -27 -16 -42 -36 -31 -41 -213 -164 -242 -164 -11 0 -25 -7 -33 -16
       -18 -22 -113 -84 -129 -84 -7 0 -32 -18 -56 -40 -28 -26 -53 -40 -70 -40 -17
       0 -42 -14 -70 -40 -24 -22 -50 -40 -59 -40 -8 0 -41 -18 -72 -40 -32 -22 -66
       -40 -75 -40 -9 0 -20 -4 -23 -10 -3 -5 -15 -10 -26 -10 -10 0 -36 -15 -56 -33
       -45 -39 -136 -87 -165 -87 -12 0 -40 -18 -64 -40 -24 -22 -52 -40 -63 -40 -11
       0 -23 -4 -26 -10 -3 -5 -15 -10 -26 -10 -24 0 -53 -16 -97 -52 -19 -17 -45
       -28 -62 -28 -16 0 -32 -4 -35 -10 -3 -5 -19 -10 -35 -10 -18 0 -52 -16 -87
       -40 -38 -26 -69 -40 -90 -40 -31 0 -79 -22 -135 -61 -14 -11 -38 -19 -53 -19
       -15 0 -38 -9 -52 -20 -14 -11 -32 -20 -40 -20 -8 0 -26 -9 -40 -20 -14 -11
       -38 -20 -54 -20 -15 0 -31 -4 -34 -10 -3 -5 -23 -10 -44 -10 -39 0 -52 -5
       -126 -51 -53 -32 -102 -49 -147 -49 -20 0 -40 -5 -43 -10 -3 -6 -19 -10 -35
       -10 -16 0 -49 -13 -73 -30 -25 -16 -54 -30 -65 -30 -12 0 -24 -5 -27 -10 -3
       -6 -17 -10 -30 -10 -13 0 -27 -4 -30 -10 -3 -5 -38 -10 -77 -10 -55 0 -75 -4
       -95 -20 -14 -11 -34 -20 -44 -20 -10 0 -21 -4 -24 -10 -3 -5 -16 -10 -29 -10
       -12 0 -26 -4 -31 -9 -6 -6 -45 -12 -88 -15 -51 -3 -87 -10 -105 -22 -19 -13
       -47 -18 -97 -18 -77 -1 -95 -8 -95 -37 0 -10 -4 -19 -10 -19 -5 0 -10 5 -10
       10 0 6 -22 10 -50 10 -39 0 -52 -4 -60 -20 -9 -16 -21 -20 -65 -20 -30 0 -55
       -4 -55 -10 0 -5 -22 -10 -49 -10 -28 0 -53 -4 -56 -10 -3 -6 -35 -10 -70 -10
       -35 0 -67 -4 -70 -10 -3 -5 -36 -10 -72 -10 -56 0 -66 -3 -70 -20 -5 -18 -14
       -20 -93 -20 -64 0 -89 -4 -93 -13 -4 -10 -43 -16 -154 -21 -112 -5 -151 -10
       -159 -21 -9 -12 -36 -15 -122 -15 -95 0 -111 -2 -106 -15 4 -8 1 -15 -5 -15
       -6 0 -11 5 -11 11 0 6 -17 9 -42 7 -36 -2 -44 -7 -46 -25 l-3 -23 -215 0
       c-136 0 -214 -4 -214 -10 0 -6 -41 -10 -104 -10 -58 0 -108 -4 -111 -10 -3 -5
       -19 -7 -35 -3 -22 4 -31 1 -36 -11 -6 -14 -60 -16 -585 -16 l-579 0 0 -35 c0
       -30 3 -35 24 -35 14 0 28 -4 31 -10 3 -6 17 -10 30 -10 13 0 27 -5 30 -10 9
       -14 68 -12 84 3 11 9 14 9 18 0 3 -10 41 -13 139 -13 83 0 134 -4 134 -10 0
       -6 74 -10 203 -10 139 0 207 -4 214 -11 8 -8 56 -12 130 -13 l118 -1 3 -27 3
       -28 360 0 c233 0 359 -4 359 -10 0 -14 767 -14 775 0 4 6 147 10 396 10 364 0
       389 1 389 18 0 14 10 17 65 17 55 0 65 -3 65 -17 0 -11 8 -18 20 -18 11 0 20
       -4 20 -10 0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0 -5 7 -10 15 -10 8 0 15 -4
       15 -10 0 -5 6 -10 13 -10 7 0 23 -9 35 -20 12 -11 28 -20 37 -20 8 0 15 -7 15
       -15 0 -11 11 -15 38 -15 26 0 45 -7 57 -20 10 -11 26 -20 37 -20 10 0 18 -4
       18 -10 0 -5 18 -10 40 -10 33 0 40 -3 40 -20 0 -12 7 -20 16 -20 9 0 28 -12
       41 -26 16 -17 31 -24 43 -21 11 3 20 1 20 -4 0 -5 29 -9 65 -9 51 0 65 -3 65
       -15 0 -8 9 -15 20 -15 13 0 20 -7 20 -20 0 -16 7 -20 30 -20 17 0 30 -5 30
       -11 0 -7 10 -9 25 -7 17 4 25 1 25 -8 0 -10 16 -14 59 -14 33 0 63 -4 66 -10
       3 -5 28 -10 55 -10 35 0 50 -4 54 -16 4 -9 13 -14 21 -10 10 4 15 -1 15 -14 0
       -18 7 -20 60 -20 33 0 60 -4 60 -10 0 -6 38 -10 94 -10 53 0 98 -4 101 -10 3
       -5 26 -10 50 -10 24 0 47 -4 50 -10 3 -5 37 -10 74 -10 51 0 72 -4 82 -16 10
       -13 27 -15 76 -12 47 3 63 1 63 -9 0 -10 60 -13 295 -13 222 0 294 3 293 12
       -2 8 11 11 38 9 27 -1 47 3 57 13 11 11 35 16 81 16 37 0 66 4 66 10 0 6 28
       10 65 10 37 0 65 4 65 10 0 6 42 10 105 10 63 0 105 4 105 10 0 6 29 10 66 10
       61 0 65 1 59 20 -5 15 -3 18 9 14 10 -4 18 0 22 10 4 11 19 16 44 16 22 0 42
       5 45 10 3 6 30 10 60 10 30 0 57 5 60 10 3 6 19 10 36 10 16 0 29 5 29 10 0 6
       14 10 31 10 22 0 32 5 36 20 4 16 14 20 44 20 28 0 39 4 39 15 0 10 10 15 30
       15 17 0 30 4 30 9 0 5 18 7 40 4 31 -4 41 -2 46 11 3 9 13 16 21 16 10 0 13 7
       8 23 -5 16 -4 18 3 8 13 -18 44 -7 36 14 -5 12 2 15 33 15 27 0 43 6 53 20 9
       13 26 20 47 20 18 0 33 5 33 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 11 15 25
       20 14 5 28 17 31 25 4 8 14 15 24 15 9 0 25 9 35 20 12 13 31 20 57 20 30 0
       38 4 38 18 0 29 64 82 100 82 34 0 71 27 63 46 -3 8 0 14 6 14 6 0 11 -4 11
       -10 0 -5 11 -10 25 -10 18 0 25 5 25 18 0 20 39 62 58 62 7 0 15 7 18 15 4 8
       15 15 25 15 10 0 19 7 19 15 0 27 47 65 80 65 18 0 30 5 30 13 0 8 12 19 26
       26 16 7 24 17 21 25 -7 18 24 46 51 46 12 0 22 4 22 8 0 5 11 14 24 21 16 9
       22 19 19 32 -3 12 0 19 8 19 8 0 20 9 27 20 7 11 19 20 27 20 24 0 65 42 65
       66 0 14 8 25 20 29 11 3 20 13 20 21 0 8 9 14 20 14 11 0 20 5 20 10 0 6 6 10
       14 10 16 0 26 21 26 56 0 15 6 24 15 24 8 0 15 5 15 10 0 6 7 10 15 10 19 0
       65 44 65 62 0 22 44 64 63 60 10 -2 17 3 17 12 0 9 6 16 14 16 8 0 16 17 19
       45 5 30 15 54 32 69 14 13 25 33 25 45 0 12 8 25 18 28 9 4 22 12 28 17 6 6
       21 18 33 26 11 8 21 25 21 37 0 13 5 23 10 23 6 0 10 9 10 20 0 13 7 20 20 20
       13 0 20 7 20 20 0 11 7 20 15 20 11 0 15 11 15 36 0 27 5 37 20 41 13 3 20 14
       20 29 0 13 5 24 10 24 6 0 10 14 10 30 0 21 5 30 16 30 25 0 44 26 44 60 0 18
       4 29 10 25 6 -4 10 5 10 19 0 14 5 26 10 26 6 0 10 12 10 28 0 16 8 32 20 40
       11 7 20 21 20 32 0 11 7 20 15 20 10 0 15 10 15 34 0 34 37 116 52 116 4 0 8
       18 8 40 0 33 3 40 20 40 13 0 20 7 20 20 0 11 5 20 10 20 6 0 10 21 10 46 0
       27 4 43 10 39 6 -4 10 12 10 39 0 25 5 46 10 46 6 0 10 18 10 40 0 22 5 40 10
       40 6 0 10 35 10 85 0 83 1 85 24 85 19 0 23 4 19 20 -4 14 0 20 11 20 10 0 16
       9 16 25 0 14 5 25 10 25 6 0 10 11 10 25 0 14 5 25 10 25 6 0 10 16 10 35 0
       19 5 35 10 35 6 0 10 85 10 235 0 195 -2 235 -14 235 -23 0 -98 65 -251 220
       -16 16 -39 39 -50 49 -11 11 -44 49 -74 85 -30 36 -60 66 -67 66 -21 0 -434
       424 -461 473 -25 45 -16 70 52 137 36 35 65 73 65 83 0 10 21 40 46 67 63 68
       87 66 156 -12 44 -49 267 -277 298 -305 10 -9 102 -116 143 -168 28 -33 32
       -35 93 -35 l64 0 0 49 c0 28 -4 53 -10 56 -6 4 -10 85 -10 211 0 129 -4 204
       -10 204 -5 0 -10 12 -10 26 0 16 -10 34 -25 46 -25 19 -25 20 -25 184 0 157
       -1 164 -20 164 -16 0 -20 7 -20 30 0 17 -4 30 -10 30 -5 0 -10 9 -10 19 0 11
       -4 23 -10 26 -5 3 -10 28 -10 56 0 27 -4 49 -10 49 -5 0 -10 14 -10 30 0 17
       -4 30 -10 30 -5 0 -10 14 -10 30 0 27 -3 30 -30 30 -30 0 -30 1 -30 55 0 30
       -4 55 -10 55 -5 0 -10 11 -10 24 0 14 -4 28 -10 31 -5 3 -10 15 -10 26 0 10
       -7 19 -15 19 -8 0 -15 5 -15 10 0 6 -9 10 -20 10 -17 0 -20 7 -20 51 0 44 -4
       55 -30 79 -16 15 -30 34 -30 42 0 7 -9 20 -20 28 -11 8 -20 26 -20 40 0 16
       -11 36 -30 52 -16 14 -30 36 -30 47 0 12 -6 21 -15 21 -10 0 -15 10 -15 30 0
       23 -5 30 -19 30 -15 0 -21 8 -23 33 -2 23 -8 32 -21 31 -10 -1 -19 7 -23 22
       -3 13 -12 28 -20 35 -8 6 -14 20 -14 30 0 12 -7 19 -18 19 -23 0 -42 19 -42
       42 0 11 -7 18 -20 18 -17 0 -20 7 -20 40 0 29 -4 40 -15 40 -8 0 -15 6 -15 14
       0 7 -13 16 -30 20 -18 3 -30 12 -30 21 0 8 -4 15 -10 15 -5 0 -10 9 -10 19 0
       11 -9 23 -20 26 -11 3 -20 13 -20 21 0 8 -8 14 -17 14 -27 1 -53 25 -62 57 -5
       15 -13 27 -20 26 -6 -2 -11 9 -11 23 0 21 -4 25 -20 21 -13 -3 -20 0 -20 9 0
       8 -4 14 -10 14 -5 0 -10 8 -10 18 0 9 -13 23 -30 30 -18 8 -30 21 -30 33 0 14
       -7 19 -27 19 -33 1 -68 24 -58 39 3 6 -1 14 -9 17 -9 3 -13 10 -10 15 3 5 -2
       9 -10 9 -9 0 -16 7 -16 15 0 8 -9 15 -20 15 -11 0 -20 5 -20 10 0 6 -7 10 -16
       10 -18 0 -44 23 -44 40 0 17 -26 40 -44 40 -9 0 -16 5 -16 10 0 6 -5 10 -11
       10 -18 0 -39 28 -33 44 5 12 -1 16 -24 16 -19 0 -39 9 -53 25 -13 13 -30 25
       -36 25 -7 0 -18 9 -25 20 -7 11 -21 20 -30 20 -11 0 -18 8 -18 20 0 14 -7 20
       -23 20 -12 0 -29 9 -37 20 -8 12 -26 20 -42 20 -15 0 -28 5 -28 10 0 6 -7 10
       -16 10 -20 0 -41 21 -46 46 -2 13 -12 19 -28 19 -14 0 -35 10 -47 23 -12 12
       -29 22 -38 22 -8 0 -15 5 -15 10 0 6 -16 10 -36 10 -35 0 -64 18 -64 40 0 23
       -30 40 -69 40 -23 0 -41 5 -41 10 0 6 -18 10 -40 10 -22 0 -40 5 -40 10 0 6
       -9 10 -20 10 -16 0 -19 5 -15 23 9 34 -16 50 -70 45 -33 -4 -45 -2 -45 9 0 8
       -11 13 -30 13 -16 0 -30 5 -30 10 0 6 -13 10 -30 10 -16 0 -30 5 -30 10 0 6
       -18 10 -40 10 -33 0 -40 3 -40 20 0 16 -7 20 -34 20 -19 0 -38 5 -41 10 -3 6
       -35 10 -71 10 -36 0 -64 -4 -64 -10 0 -5 -20 -10 -45 -10 -25 0 -45 5 -45 10
       0 6 -22 10 -50 10 -27 0 -50 5 -50 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0
       6 -28 10 -65 10 -37 0 -65 4 -65 10 0 6 -45 10 -115 10 -70 0 -115 4 -115 10
       0 7 -180 10 -520 10 -340 0 -520 -3 -520 -10z"/>
       </g>
       </svg>
       
    
    );
};



export default MontaniaIcon;